/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('FbInstantPurchaseSignedData' in value) || value['FbInstantPurchaseSignedData'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSON(json) {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
        'FbInstantPurchaseSignedData': json['FbInstantPurchaseSignedData'],
        'PublicOrderId': json['PublicOrderId'] == null ? undefined : json['PublicOrderId'],
        'DeveloperPayloadHint': json['DeveloperPayloadHint'] == null ? undefined : json['DeveloperPayloadHint'],
    };
}
export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSON(json) {
    return FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'FbInstantPurchaseSignedData': value['FbInstantPurchaseSignedData'],
        'PublicOrderId': value['PublicOrderId'],
        'DeveloperPayloadHint': value['DeveloperPayloadHint'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest.js.map